import MainTable, { MainTableColumn } from '@/components/company/table/MainTable';
import { axiosTasklist } from '@/utils/lib/axiosTasklist';
import { DataConfig } from '@/utils/hooks/useDefaultDataConfig';
import { IJobDescription, IJobDescriptionPaginatedResponse } from '@/states/job.state';
import { useMemo } from 'react';

interface Props {
  isLoading: boolean;
  paginatedData: IJobDescriptionPaginatedResponse;
  pageConfig: DataConfig;
  setPageConfig: React.Dispatch<React.SetStateAction<DataConfig>>;
  onEdit: (row: IJobDescription) => void;
}

export default function ReportTable({ isLoading, paginatedData, pageConfig, setPageConfig, onEdit }: Props) {
  const columns: MainTableColumn[] = useMemo(
    () => [
      { name: 'role', label: 'Role', render: (_, row) => row?.org_chart_node?.name ?? '-' },
      { name: 'key_activity', label: 'Key Activities', render: (_, row) => row?.org_key_activity?.name ?? '-' },
      { name: 'name', label: 'Job Description' },
      { name: 'frequency', label: 'Frequency' },
      { name: 'report', label: 'Report' },
      {
        name: 'report_file',
        label: 'Template',
        render: (val: any) => {
          if (!val) return '-';
          try {
            const files = JSON.parse(val);
            if (!files.length) return '-';
            const file = files[0];
            const fileUrl = `${axiosTasklist.defaults.cloudStorage}${file.url}`;
            const displayName = file.original_name || file.filename || file.path?.split('/').pop() || 'Unnamed File';
            return (
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline cursor-pointer hover:text-blue-800"
              >
                {displayName}
              </a>
            );
          } catch {
            return '-';
          }
        },
      },
    ],
    [],
  );

  return (
    <MainTable
      showHeader={false}
      isLoading={isLoading}
      data={{
        content: paginatedData.content as unknown as Record<string, unknown>[],
        totalElements: paginatedData.totalElements,
        totalPages: paginatedData.totalPages,
      }}
      columns={columns}
      pageConfig={pageConfig}
      setPageConfig={setPageConfig}
      onEdit={onEdit}
      showActions
    />
  );
}
